import { Switch } from '@/components/ui/switch';
import { cn } from '@/lib/utils';

interface PremiumModuleToggleProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  disabled?: boolean;
}

export const PremiumModuleToggle = ({
  icon,
  title,
  description,
  enabled,
  onToggle,
  disabled = false
}: PremiumModuleToggleProps) => {
  return (
    <div 
      className={cn(
        "flex items-center justify-between p-4 rounded-lg",
        "bg-background/30 backdrop-blur-sm",
        "border border-primary/10",
        "transition-all duration-300",
        "hover:border-primary/30 hover:bg-background/50",
        "hover:shadow-[0_0_15px_rgba(139,92,246,0.15)]",
        disabled && "opacity-50"
      )}
    >
      <div className="flex items-start gap-3 flex-1 min-w-0">
        <div className="mt-0.5 flex-shrink-0 text-muted-foreground">
          {icon}
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="font-medium text-foreground mb-1">
            {title}
          </h4>
          <p className="text-sm text-muted-foreground">
            {description}
          </p>
        </div>
      </div>
      
      <Switch
        checked={enabled}
        onCheckedChange={onToggle}
        disabled={disabled}
        className="flex-shrink-0 ml-4"
        aria-label={`Toggle ${title}`}
      />
    </div>
  );
};